import { SimpleStringObject } from '@/lib/types.ts';
import Helpers from '@/lib/helpers.ts';

const Fetch: any = {
    async get(location: string, params?: SimpleStringObject) {
        const req = await fetch(location,
            { method: 'GET', ...params },
        );
        if (req.status !== 404) {
            return await req.json();
        } else {
            return null;
        }
    },
    async post(location: string, params?: SimpleStringObject) {
        let req;
        if (params) {
            req = await fetch(location, {method: 'POST', body: JSON.stringify(params)});
        } else {
            req = await fetch(location, { method: 'POST' });
        }
        return await req.json();
    },
};

export default Fetch;
